export default class FiltroPedidosDigitacao{
    constructor () {

    }
}